/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requirements_Locality_Ruian_HintInputs */

const cs_requirements_locality_ruian_hint = /** @type {(inputs: Requirements_Locality_Ruian_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vyhledáním v RÚIAN vyplníte město / část, pak lokalitu vytvořte.`)
};

const en_requirements_locality_ruian_hint = /** @type {(inputs: Requirements_Locality_Ruian_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search RÚIAN to fill city / district, then create the locality.`)
};

/**
* | output |
* | --- |
* | "Search RÚIAN to fill city / district, then create the locality." |
*
* @param {Requirements_Locality_Ruian_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const requirements_locality_ruian_hint = /** @type {((inputs?: Requirements_Locality_Ruian_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requirements_Locality_Ruian_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requirements_locality_ruian_hint(inputs)
	return cs_requirements_locality_ruian_hint(inputs)
});